import { render, staticRenderFns } from "./MemberDetailLink.vue?vue&type=template&id=2e85018b&scoped=true&"
import script from "./MemberDetailLink.vue?vue&type=script&lang=js&"
export * from "./MemberDetailLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e85018b",
  null
  
)

export default component.exports